<script>
import { BSpinner } from 'bootstrap-vue';

export default {
  components: {
    BSpinner,
  },

  props: {
    outbound: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      name: '',
      email: '',
      password: '',
      terms: false,
      loadingRegister: false,
      errors: {
        terms: false
      }
    }
  },
  computed: {
    nameText() {
      let start = this.name ? ' ' : '';
      return start + this.name;
    }
  },
  methods: {
    register() {
      if(!this.terms) {
        this.errors.terms = true;
        return;
      }

      this.errors.terms = false;
      this.loadingRegister = true;

      const payload = {
        name: this.name,
        email: this.email,
        password: this.password,
        terms: this.terms,
        outbound: this.outbound,
      };


      this.$http.post('/register/user', payload)
        .then(response => {
          sessionStorage.removeItem('resendTime');
          localStorage.setItem('verify-email', this.email);
          window.location.href = '/verificar-email';
        }).catch(error => {
          if(error.status === 409) return Alert.error(this.__('Usuário já existente'));
          Alert.error(this.__('Tivemos um problema ao realizar o seu cadastro, tente novamente em instantes.'));
        })
        .finally(() => { this.loadingRegister = false; });
    }
  }
}
</script>

<template>
  <div class="hero col-sm-12 col-lg-6">
    <div class="d-flex justify-content-center">
      <img src="/build/images/logo-new.png" width="230" class="sf-logo" alt="">
    </div>
    <div class="p-0">
      <h1 class="bdk-mb-6">{{ __('Olá') }}{{ nameText }}!</h1>
      <form action="" @submit.prevent="register()">
        <div class="form-group-item">
          <label for="name">{{ __('Nome') }}</label>
          <input type="text" name="name" v-model="name" maxlength="52" required>
        </div>

        <div class="form-group-item">
          <label for="email">E-mail</label>
          <input type="email" name="email" placeholder="nome@email.com" v-model="email" required>
        </div>

        <div class="form-group-item">
          <label for="password">{{ __('Escolha uma senha') }}</label>
          <input type="password" name="password" v-model="password" required minlength="8">
          <span class="hint">{{ __('Sua senha deve conter no mínimo 8 caracteres') }}</span>
        </div>

        <div class="form-group-item terms-checkbox">
          <label class="checkbox-custom terms">
            <input type="checkbox" id="checkbox-terms" v-model="terms" hidden />
            <span class="checkmark"></span>

            <span>
              {{ __('Li e concordo com os') }} <a target="_blank"
                href="https://salesflowcrm.movidesk.com/kb/article/405957/termos-de-uso">{{ __('Termos de Uso') }}</a>
            </span>
          </label>
          <span class="hint error" v-if="errors.terms">{{__('Aceite os nossos Termos de Uso antes de prosseguir')}}</span>
        </div>

        <button type="submit" class="btn btn-block btn-submit" :disabled="loadingRegister">
          <BSpinner v-if="loadingRegister" small="small" />
          <template v-else>{{ __('Criar minha conta') }}</template>
        </button>

      </form>
    </div>
    <div class="d-flex justify-content-center">
      <span class="has-account"> {{ __('Já possui uma conta?') }}
        <a href="/login" class="">{{ __('Faça seu login') }}</a>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  color: #242424;
  font-size: 28px;
  font-weight: 700;
  line-height: 150%;
}

// base style and phone
.hero {
  background-color: #FBFBFB;
  border-radius: 20px 20px 0px 0px;
  -webkit-box-shadow: 8px 8px 35px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 8px 8px 35px 0px rgba(0, 0, 0, 0.08);
  box-shadow: 8px 8px 35px 0px rgba(0, 0, 0, 0.08);
  width: 100%;
  min-height: 685px;
  padding: 40px 32px;
  overflow: scroll;
}

// small-height-screen phones
@media screen and (max-height: 840px) and (max-width: 540px) {
  .hero {
    height: 100vh;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    border-radius: 0px !important;
  }

  .sf-logo,
  .btn-submit {
    margin-bottom: 40px !important;
  }
}

.sf-logo {
  width: 199.875px;
  height: 43.348px;
  margin-bottom: 54px;
}

// tablet
@media screen and (min-width: 744px) {
  .hero {
    min-height: 706px;
    padding: 40px 80px;
  }

  .sf-logo,
  .btn-submit {
    margin-bottom: 64px !important;
  }
}

// desktop
@media screen and (min-width: 992px) {
  .hero {
    height: 700px;
    max-width: 640px !important;
    border-radius: 40px;
    padding: 48px 80px;
  }

  .sf-logo {
    width: 241.849px;
    height: 52.451px;
    margin-bottom: 48px !important;
  }

  .btn-submit {
    margin-bottom: 48px !important;
  }
}

// small resolution desktops
@media screen and (min-width: 992px) and (max-height: 750px) {
  .hero {
    min-height: 95%;
    max-height: 95%;
  }
}

form {
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.terms-checkbox {
  display: flex;
  gap: 8px;
}

.terms {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #242424;
  font-weight: 700 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;

  a {
    color: #886AF8;
    font-weight: 400;
  }

  a:hover {
    color: #5F33FF;
  }
}

.has-account {
  font-size: 12px;
  color: #71767D;
}

.has-account a {
  color: #71767D;
  text-decoration: underline;
}

.has-account a:hover {
  color: #242424;
}

.form-group-item {
  width: 100%;
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 0;
    margin-left: 16px;
    font-size: 12px;
    margin-bottom: 8px;
  }

  input {
    border: 1px solid #F0F0F0;
    border-radius: 12px;
    padding: 10px 12px;
    color: #242424;
    font-size: 12px
  }

  input:active {
    border: 1px solid #8869FD;
  }

  input:focus {
    border: 1px solid #8869FD;
  }

  input:focus-visible {
    outline: none !important;
  }

  span.hint {
    font-size: 14px;
    color: #6C757D;
    font-weight: 400;
  }
  span.error {
    font-size: 12px;
    color: #FF2E56;
  }
}

/* Estilo do substituto visual do checkbox */
.checkbox-custom .checkmark {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1px solid #d9d9d9;
  /* Cor da borda quando não marcado */
  border-radius: 4px;
  /* Borda arredondada para estética, opcional */
  margin-right: 8px;
  vertical-align: middle;
  position: relative;
  /* Necessário para posicionar o pseudo-elemento corretamente */
}

/* Quando o checkbox está marcado, muda o estilo do substituto visual */
.checkbox-custom input:checked+.checkmark {
  background-color: #8869FD;
  /* Cor de fundo quando marcado */
}

/* Adiciona o visto (✓) quando marcado */
.checkbox-custom input:checked+.checkmark::after {
  content: "✓";
  color: white;
  /* Cor do visto */
  font-size: 12px;
  /* Tamanho do visto */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* Centraliza o visto */
  pointer-events: none;
  /* Impede que o pseudo-elemento interfira no clique */
}

/* Oculta visualmente o checkbox real, mas mantém acessibilidade */
.checkbox-custom input {
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  position: absolute;
}

.btn-submit {
  background-color: #886AF8;
  border-radius: 12px;
  color: white;
  padding: 8px 32px;
  margin-bottom: 54px;
}

.btn-submit:hover {
  background-color: #5F33FF;
  -webkit-box-shadow: 0px 4px 32px 0px rgba(95, 51, 255, 0.24);
  -moz-box-shadow: 0px 4px 32px 0px rgba(95, 51, 255, 0.24);
  box-shadow: 0px 4px 32px 0px rgba(95, 51, 255, 0.24);
}

.hero::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
.hero {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
